import React, { useState } from 'react';
import Input from '../../../shared/forms/Input';
import Modal, { ModalCloseButton } from '../../../shared/modals/Modal';

const CancelSubscriptionModal = ({setCancelSubscriptionModalVisible, cancelSubscription}) => {
  const [answer, setAnswer] = useState('');
  const [cancelled, setCancelled] = useState(false);
  const closeModal = () => setCancelSubscriptionModalVisible(false);

  return (
    <Modal isOpen={true} onClose={closeModal}>
      <div className='modal'>
        {cancelled && (
          <>
            <div className='modal__header'>
              <h3 className='margin-none'>Your subscription has been scheduled for cancellation.</h3>
              <ModalCloseButton
                onClick={closeModal}
                label="Close cancellation modal"
              />
            </div>

            <div className="modal__body">
              <p>You will continue to have access until the end of your current billing period.</p>
              <p>After that, you will not be charged again.</p>
            </div>
            <div className='modal__footer'>
              <button
                type="button"
                className='btn primary'
                onClick={closeModal}
              >
                OK
              </button>
            </div>
          </>
        )}

        {!cancelled && (
          <>
            <div className='modal__header'>
              <h3 className='margin-none'>Are you sure you want to cancel your subscription?</h3>
              <ModalCloseButton
                onClick={closeModal}
                label="Close cancellation modal"
              />
            </div>

            <div className="modal__body">
              <form
                id="cancel-subscription-form"
                onSubmit={(e) => {
                  e.preventDefault();
                  if (answer === 'Yes') {
                    cancelSubscription();
                    setCancelled(true);
                  }
                }}
              >
                <p>To confirm, type Yes in the box below and click Cancel Subscription.</p>
                <Input onChange={(e) => setAnswer(e.target.value)} />
              </form>
            </div>
            <div className='modal__footer'>
              <button
                type="button"
                className="btn secondary"
                onClick={closeModal}
              >
                  Keep Subscription
              </button>
              <button type="submit" form="cancel-subscription-form" className='btn destructive'>
                Cancel Subscription
              </button>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
}

export default CancelSubscriptionModal;
